import React, { Suspense } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import routes from "./router";
import { HelmetProvider } from "react-helmet-async";

import Spinner from "./components/common/Spinner";
import ScrollToTop from "react-scroll-to-top";
import { NotFound } from "./components/common/NotFound";
// import 'rsuite/dist/rsuite-no-reset.min.css';
import "rsuite/styles/index.less";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="w-screen h-screen">
              <Spinner />
            </div>
          }
        >
          <div className="App">
            <Routes>
              {routes.map((route, index) => {
                return (
                  <Route
                    element={
                      <>
                        <ScrollToTop
                          className="hidden sm:block"
                          component={
                            <img
                              alt="Arrow upward alt"
                              className=""
                              src="/assets/images/scrollup.svg"
                            />
                          }
                          smooth
                          style={{
                            backgroundColor: "unset",
                            borderRadius: "100%",
                            right: 20,
                            bottom: 84,
                            width: 48,
                            height: 48,
                            boxShadow: "unset",
                            zIndex: 20,
                          }}
                        />
                        <route.component />
                      </>
                    }
                    key={index}
                    path={route.path}
                  />
                );
              })}
              <Route element={<NotFound />} path="*" />
            </Routes>
          </div>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
